import styled from "styled-components";
import { StyledHomePageSectionBlock } from "../styledHomePage";
import { motion } from "framer-motion";

export const StyledAboutProjectHomePageSection = styled(motion.div) `
  padding-top: calc(131px - 55px);
  position: relative;
  @media (max-width: 576px) {
    padding-top: calc(50px - 55px);
    transform: none !important;
    transition: none !important;
  }

  &:after {
    width: 100%;
    max-width: 620px;
    height: 620px;
    content: '';
    position: absolute;
    bottom: -65px;
    right: -200px;
    border-radius: 50%;
    background: rgba(155, 104, 228, 0.3);
    filter: blur(100px);
    @media(max-width: 576px) {
      bottom: 10px;
      filter: blur(30px);
    }
  }
`


export const StyledAboutProjectHomePageBlock = styled(StyledHomePageSectionBlock)`
  padding: 0 15px;
`

export const StyledAboutProjectInfo = styled(motion.div)`
  display: flex;
  justify-content: space-between;
 
  .lets-try-btn {
   display: none;
  }
  
  div:first-child {
    z-index: 10;
  }

  .main-title {
    color: #000000;
  }
  button {
    padding: 20px 50px;
    border-radius: 10px;
    &:hover {
      background-color: #9B68E4;
      border: 1px solid #9B68E4;
      .sing-up-btn {
        color: #FFFFFF;
      }
    }
    @media(max-width: 768px) {
      padding: 10px 33px;
      background-color: #9F65E9;
      border: 2px solid #9F65E9;
      &:hover{
        background-color: #8e4ce3;
        border: 2px solid #8e4ce3;
      }
      .lets-try-btn {
        display: block;
      }
      .sing-up-btn {
        display: none;
      }
    }
  }

  img {
    padding-right: 90px;
    width: 100%;
    max-width: 500px;
  }

  @media (max-width: 992px) {
    .main-title {
      font-size: 40px;
      line-height: 40px;
    }

    .main-description {
      margin: 30px 0;
      font-size: 20px;
    }
    img {
      padding-right: 0;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    button {
     margin-bottom: 40px; 
    }
    div:first-child {
      text-align: center;
      .main-title {
        text-align: inherit;
      }
      .main-description {
        font-size: 16px;
        margin: 25px auto 20px;
        text-align: left;
        line-height: 20px;
      }
    }
    img {
      position: relative;
      left: 70px;
    }
  }
  @media (max-width: 768px) {
    div:first-child {
      .main-title {
        margin-top: 50px;
        font-size: 40px;
      }
    }
  }
  
  @media (max-width: 576px) {
    animation: none;
  }
  
`

export const StyledBringAllTheContactBlock = styled.div`
  padding: 0 15px;
  @media (max-width: 768px) {
    padding: 0;
    background-color: transparent;
    z-index: 1;
    position: relative;
  }
`

export const StyledBringAllTheContactContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  padding: 45px 72px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: linear-gradient(343.57deg, rgba(211, 211, 211, 0) -40.79%, #FFFFFF 79.32%);
  border: 2px solid #C1B2D7;
  border-radius: 10px;
  position: relative;
  
  div:last-child {
    z-index: 10;

    .action-btn-manual {
      border-radius: 10px;
      width: 46px;
      height: 46px;

      span:nth-child(2) {
        display: none;
      }
 
      &:hover {
        background-color: #9B68E4;
        border: 1px solid #9B68E4;

        span {
          color: #FFFFFF;
        }
      }

      .icon-chevron-right {
        position: relative;
        left: -5px;
      }
      
      @media (max-width: 576px) {
        padding: 8px 35px;
        background-color: #9F65E9;
        border: 2px solid #9F65E9;
        &:hover {
          background-color: #8e4ce3;
          border: 2px solid #8e4ce3;
        }

        .icon-chevron-right {
          display: none;
        }

        span:nth-child(2) {
          display: block;
        }
      }
    }
  }

  @media (max-width: 992px) {
    padding: 45px 35px;
  }

  @media (max-width: 768px) {
    border: none;
    padding: 45px 15px;
    border-radius: initial;
    border-top: 1px solid #C1B2D7;
    border-bottom: 1px solid #C1B2D7;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    div:last-child {
      .action-btn-manual {
        border-radius: 10px;
        width: 100%;
        height: 100%;
      }
    }
  }
`

export const StyledTypeChatIcon = styled.div`
  display: flex;
  
  .logo {
    width: 70px;
    height: 70px;
    
    img {
      width: 100%;
      height: 100%;
      object-position: center;
      object-fit: contain;
    }
  }

  .circle:nth-child(2) {
    margin: 0 15px;
  }
  
  .circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    position: relative;
    cursor: pointer;

    img {
      width: 40px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: all .3s ease;
    }
  }

  .telegram {
    background: linear-gradient(180deg, #2AABEE 0%, #229ED9 100%);
  }

  .viber {
    background: #7F4DA0;
  }

  .global {
    background: #1725A0
  }

  @media (max-width: 992px) {
    .circle {
      height: 47px;
      width: 47px;

      img {
        width: 25px;
      }
    }
  }

  @media (max-width: 576px) {
    display: none;
  }
`

export const StyledBringInfo = styled.div`
  display: flex;
  min-width: 280px;
  align-items: center;
  justify-content: space-between;
  gap: 25px;

  div:first-child {
    max-width: 530px;
  }

  .response-icon {
    display: none;
  }

  @media (max-width: 992px) {
    h5 {
      font-size: 20px;
    }

    .bring-info-text {
      font-size: 16px;
    }
  }

  @media (max-width: 576px) {
    h5 {
      margin: 0 auto;
      max-width: 250px;
      text-align: center;
      line-height: 24px;
    }

    .bring-info-text {
      font-size: 14px;
      line-height: 17px;
    }

    flex-direction: column;
    .response-icon {
      margin: 15px 0;
      display: flex;
      justify-content: center;

      .circle {
        span {
          font-size: 25px;
        }
      }
    }
  }

`